import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const cortezConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Cortez Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Cortez, FL. Sam\'s Tree Service handles dangerous coastal trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_cortez',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Cortez',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Cortez Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     waterfront community of <strong>Cortez</strong>. As one of Florida's oldest fishing 
     villages, Cortez properties sit right along the water where salt air, tidal winds, 
     and storm surge exposure take a serious toll on trees. Weakened, leaning, or overgrown 
     trees near docks, homes, and boats require experienced hands, and that's exactly what 
     we deliver.`,

    `We specialize in <strong>hazardous tree removal and coastal trimming</strong>
     including salt damaged canopies, wind stressed palms leaning toward structures or 
     waterways, heavy overhanging limbs near docks and buildings, and dense growth that 
     dramatically increases storm risk. No coastal job is too complex for our crew.`,

    `<strong>Sam's Tree Service</strong> provides dependable, expert tree care throughout 
     <strong>Cortez</strong> and the surrounding <strong>Sarasota Bay and Anna Maria 
     Island</strong> area protecting your waterfront property and keeping your landscape 
     safe all year long.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Cortez, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Cortez = () => <LocationPage config={cortezConfig} />;
export default Services_Cortez;
